import { Locale } from "~types/wardenclyffe";

export const isLanguageCodeJa = (languageCode: Locale = Locale.En) =>
    languageCode === Locale.Ja;
